import { createAction } from '@reduxjs/toolkit';

import { CoDriverDownloadPayload } from './types';

export { setDownloadStatus, setSelection } from './reducer';

export const startDownload = createAction('CODRIVER_START_DOWNLOAD', (params: CoDriverDownloadPayload) => ({
    payload: { params },
}));
